import { render, staticRenderFns } from "./ContentMain.vue?vue&type=template&id=9010b65a&"
import script from "./ContentMain.vue?vue&type=script&lang=js&"
export * from "./ContentMain.vue?vue&type=script&lang=js&"
import style0 from "./ContentMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports